import React, { useState, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/product/CoffeeValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { CoffeeContext } from "../Coffee";

axios.defaults.baseURL = API;

function CreateCoffee(props) {

    const {CoffeeList, setCoffeeList, setShowData, CountryList, FarmList, TypeList, GradeList, BeanStatusList, ProccessList, RoasterTypeList, data} = useContext(CoffeeContext);
    const [VarityList, setVarityList] = useState([]);

    const handleInputChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        if(name === "Barcode")
            check(value);
    };

    async function check (barcode) {
        let token = localStorage.getItem("token");
        await axios.put(`/checkBarcode/${barcode}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        let temOrder = response?.data;
        if(temOrder.length > 0){
            handleChange("CheckBarcode", temOrder[0].Barcode);
        } else {
            handleChange("CheckBarcode", "");
        }
        }).catch((err) => {
            handleChange("CheckBarcode", "");
            console.log(err);
        });
      }

    const handelInputNumber = (e) => {
        const { name, value } = e.target;
          const re = /^[0-9\b]+$/;
          if (value) {
              if (value === '' || re.test(value.split(',').join(''))) {
                  handleChange(name, value.split(',').join(''));
              }  
          } else {
              handleChange(name, 0);
          }
      }

      const handleSelectCountry= (e) => {
        var data = CountryList.filter(function (item) {
            return item.Country == e.target.value
        })
        if (data.length > 0) {
            handleChange("Country", data[0].Country);
            handleChange("CountryID", data[0].CountryID);
        } else {
            handleChange("Country", "");
            handleChange("CountryID", "");
        }
    };

    const handleSelectFarm = (e) => {
        var data = FarmList.filter(function (item) {
            return item.Farm == e.target.value
        })
        if (data.length > 0) {
            handleChange("Farm", data[0].Farm);
            handleChange("FarmID", data[0].FarmID);
        } else {
            handleChange("Farm", "");
            handleChange("FarmID", "");
        }
    };

    
      const handleSelectType = (e) => {
        const { value } = e.target;
        if(value){
            console.log(e.target.children[e.target.selectedIndex].getAttribute('data-id'));
            getVarityByTypeID(e.target.children[e.target.selectedIndex].getAttribute('data-id'));
            handleChange("Type", value);
            handleChange("TypeID", e.target.children[e.target.selectedIndex].getAttribute('data-id'));
        } else {
            handleChange("Type", "");
            handleChange("TypeID", "");
            handleChange("Varity", "");
            handleChange("VarityID", "");
        }
        
    };

    async function getVarityByTypeID(value) {
        let token = localStorage.getItem("token");
        await axios.get(`/getAllVarityByTypeID/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
          let temOrder = response?.data;
          console.log(temOrder)
          if(temOrder.length > 0){
            setVarityList(temOrder);
          } else {
            setVarityList([]);
          }
        }).catch((err) => {
            setVarityList([]);
            console.log(err);
        });
    }

    const handleSelectVarity = (e) => {
        var data = VarityList.filter(function (item) {
            return item.Varity == e.target.value
        })
        if (data.length > 0) {
            handleChange("Varity", data[0].Varity);
            handleChange("VarityID", data[0].VarityID);
        } else {
            handleChange("Varity", "");
            handleChange("VarityID", "");
        }
    };

    const handleSelectGrade = (e) => {
        var data = GradeList.filter(function (item) {
            return item.Grade == e.target.value
        })
        if (data.length > 0) {
            handleChange("Grade", data[0].Grade);
            handleChange("GradeID", data[0].GradeID);
        } else {
            handleChange("Grade", "");
            handleChange("GradeID", "");
        }
    };

    const handleSelectBeanStatus = (e) => {
        var data = BeanStatusList.filter(function (item) {
            return item.BeanStatus == e.target.value
        })
        if (data.length > 0) {
            handleChange("BeanStatus", data[0].BeanStatus);
            handleChange("BeanStatusID", data[0].BeanStatusID);
        } else {
            handleChange("BeanStatus", "");
            handleChange("BeanStatusID", "");
        }
    };

    const handleSelectProccess = (e) => {
        var data = ProccessList.filter(function (item) {
            return item.Proccess == e.target.value
        })
        if (data.length > 0) {
            handleChange("Proccess", data[0].Proccess);
            handleChange("ProccessID", data[0].ProccessID);
        } else {
            handleChange("Proccess", "");
            handleChange("ProccessID", "");
        }
    };

     const handleSelectRoaster = (e) => {
        var data = RoasterTypeList.filter(function (item) {
            return item.Roaster == e.target.value
        })
        if (data.length > 0) {
            handleChange("Roaster", data[0].Roaster);
            handleChange("RoasterID", data[0].RoasterID);
        } else {
            handleChange("Roaster", "");
            handleChange("RoasterID", "");
        }
    };

    async function saveTutorial() {
        let token = localStorage.getItem("token");
        var data = {
            Barcode: values.Barcode,
            ProductName: values.ProductName,
            Buy_Price: values.Buy_Price,
            Sell_Price: values.Sell_Price,
            CountryID: values.CountryID,
            FarmID: values.FarmID,
            VarityID: values.VarityID,
            TypeID: values.TypeID,
            GradeID: values.GradeID,
            BeanStatusID: values.BeanStatusID,
            ProccessID: values.ProccessID,
            RoasterID: values.RoasterID,
            TestNote: values.TestNote,
            StatusID: 1,
        }
        await axios.post("/CreateCoffee", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            getAllCoffee();
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    async function getAllCoffee() {
        axios.get("/getAllCoffee").then((response) => {
          let Data = response?.data;
          setCoffeeList(Data);
          setShowData(Data);
        }).catch((error) => {
          console.log(error);
        });
    }

    const ClearData = () => {
        handleChange("Barcode", "");
        handleChange("ProductName", "");
        handleChange("EngName", "");
        handleChange("Buy_Price", "");
        handleChange("Sell_Price", "");
        handleChange("TestNote", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(saveTutorial, validate);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="popUpcontent">
                <div className="popUpHeader">
                    <span>ສ້າງຂໍ້ມູນກາເຟ</span>
                </div>
                <div className="popUpBody">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="form-group">
                                <span>Barcode</span>
                                <input className={`input form-control ${errors.Barcode && 'is-invalid'}`} type="text" name="Barcode" onChange={(e) => handleInputChange(e)} value={values.Barcode || ''} required />
                                {errors.Barcode && (
                                    <p className="invalid-feedback">{errors.Barcode}</p>
                                )}
                            </div>
                            <div className="form-group">
                                <span>ຊື່ກາເຟ</span>
                                <input className={`input form-control ${errors.ProductName && 'is-invalid'}`} type="text" name="ProductName" onChange={(e) => handleInputChange(e)} value={values.ProductName || ''} required />
                                {errors.ProductName && (
                                    <p className="invalid-feedback">{errors.ProductName}</p>
                                )}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <span>ລາຄາຊື້</span>
                                <input className={`input form-control ${errors.Buy_Price && 'is-invalid'}`} type="text" name="Buy_Price" onChange={(e) => handelInputNumber(e)} value={values.Buy_Price || ''} required />
                                {errors.Buy_Price && (
                                    <p className="invalid-feedback">{errors.Buy_Price}</p>
                                )}
                            </div>
                            <div className="form-group">
                                <span>ລາຄາຂາຍ</span>
                                <input className={`input form-control ${errors.Sell_Price && 'is-invalid'}`} type="text" name="Sell_Price" onChange={(e) => handelInputNumber(e)} value={values.Sell_Price || ''} required />
                                {errors.Sell_Price && (
                                    <p className="invalid-feedback">{errors.Sell_Price}</p>
                                )}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>ປະເທດ: </label>
                                <select name="CountryID" onChange={(e) => handleSelectCountry(e)}
                                    className={`input form-control ${errors.CountryID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກປະເທດ'}
                                    </option>
                                    {   CountryList && CountryList.map(item => (
                                        <option
                                            key={item.CountryID }
                                            data-id={item.CountryID}
                                            value={item.Country}
                                        >
                                            {item.Country}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>ສວນ: </label>
                                <select name="FarmID" onChange={(e) => handleSelectFarm(e)}
                                    className={`input form-control ${errors.FarmID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກສວນ'}
                                    </option>
                                    {   FarmList && FarmList.map(item => (
                                        <option
                                            key={item.FarmID}
                                            data-id={item.FarmID}
                                            value={item.Farm}
                                        >
                                            {item.Farm}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>ປະເພດ: </label>
                                <select name="TypeID" onChange={(e) => handleSelectType(e)}
                                    className={`input form-control ${errors.TypeID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລີອກປະເພດ'}
                                    </option>
                                    {   TypeList && TypeList.map(item => (
                                        <option
                                            key={item.TypeID}
                                            data-id={item.TypeID}
                                            value={item.Type}
                                        >
                                            {item.Type}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>ສາຍພັນ: </label>
                                <select name="VarityID" onChange={(e) => handleSelectVarity(e)}
                                    className={`input form-control ${errors.VarityID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກສາຍພັນ'}
                                    </option>
                                    {   VarityList && VarityList.map(item => (
                                        <option
                                            key={item.VarityID}
                                            value={item.Varity}
                                        >
                                            {item.Varity}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>ເກດເມັດ</span>
                                <select name="GradeID" onChange={(e) => handleSelectGrade(e)}
                                    className={`input form-control ${errors.GradeID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກເກດເມັດ'}
                                    </option>
                                    {   GradeList && GradeList.map(item => (
                                        <option
                                            key={item.GradeID}
                                            value={item.Grade}
                                        >
                                            {item.Grade}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>ສະຖານະເມັດ</span>
                                <select name="BeanStatusID" onChange={(e) => handleSelectBeanStatus(e)}
                                    className={`input form-control ${errors.BeanStatusID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກສະຖານະເມັດກາເຟ'}
                                    </option>
                                    {   BeanStatusList && BeanStatusList.map(item => (
                                        <option
                                            key={item.BeanStatusID}
                                            value={item.BeanStatus}
                                        >
                                            {item.BeanStatus}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Proccess: </label>
                                <select name="ProccessID" onChange={(e) => handleSelectProccess(e)}
                                    className={`input form-control ${errors.ProccessID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກປະເພດ Proccess'}
                                    </option>
                                    {   ProccessList && ProccessList.map(item => (
                                        <option
                                            key={item.ProccessID}
                                            value={item.Proccess}
                                        >
                                            {item.Proccess}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>ປະເພດຂົ້ວ</span>
                                <select name="RoasterID" onChange={(e) => handleSelectRoaster(e)}
                                    className={`input form-control ${errors.RoasterID && 'is-invalid'}`}>
                                    <option
                                        key={""}
                                        value={""}
                                    >
                                        {'ເລືອກປະເພດຂົ້ວ'}
                                    </option>
                                    {   RoasterTypeList && RoasterTypeList.map(item => (
                                        <option
                                            key={item.RoasterID}
                                            value={item.Roaster}
                                        >
                                            {item.Roaster}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>TestNote</span>
                                <input className={`input form-control ${errors.TestNote && 'is-invalid'}`} type="text" name="TestNote" onChange={(e) => handleInputChange(e)} value={values.TestNote || ''} required />
                                {errors.TestNote && (
                                    <p className="invalid-feedback">{errors.TestNote}</p>
                                )}
                            </div>
                        </div>
                        <div className="popUpfooter">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateCoffee;
